import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
export interface StarsProps {
  rating: number;
  overrideColor?: string;
  className?: string;
}
export const Star = t0 => {
  const $ = _c(2);
  const {
    overrideColor
  } = t0;
  const t1 = overrideColor ?? "currentColor";
  let t2;
  if ($[0] !== t1) {
    t2 = <svg className="h-4 w-4 text-amber-400" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill={t1} d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" /></svg>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const HalfStar = t0 => {
  const $ = _c(3);
  const {
    overrideColor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("h-4 w-4 text-amber-400", "rtl:-scale-x-100");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = overrideColor ?? "currentColor";
  let t3;
  if ($[1] !== t2) {
    t3 = <svg className={t1} aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill={t2} d="M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z" /></svg>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export const Stars = t0 => {
  const $ = _c(4);
  const {
    rating,
    overrideColor
  } = t0;
  const hasHalfStar = rating % 1 !== 0;
  const intRating = Math.floor(rating);
  let t1;
  if ($[0] !== hasHalfStar || $[1] !== intRating || $[2] !== overrideColor) {
    t1 = intRating > 0 || intRating === 0 && hasHalfStar ? <div className="flex h-4 flex-row">{intRating > 0 && Array.from(Array(intRating)).map((_, i) => <Star key={i} overrideColor={overrideColor} />)}{hasHalfStar && <HalfStar overrideColor={overrideColor} />}</div> : null;
    $[0] = hasHalfStar;
    $[1] = intRating;
    $[2] = overrideColor;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};